/// <reference path="lib/jquery.autocomplete.js" />
/// <reference path="lib/jquery.autocomplete.js" />
/// <reference path="lib/foundation-explicit-pieces.js" />

import lottie from "lottie-web";


import $ from 'jquery';
import 'what-input';

// libraries
import fitvids from 'fitvids';

// modules
import initLazyload from './modules/lazyload';
import initHeader from './modules/header';
import initSliders from './modules/sliders';
import initEllipsis from './modules/ellipsis';
import initSelect from './modules/select';
import initMap from './modules/map';
import initServiceMap from './modules/mapServices';
import initForms from './modules/forms';
// import FillPostal from './modules/forms';
import productFilter from './modules/productFilter';


// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

import './lib/foundation-explicit-pieces';

import initLocationSelector from './modules/LocationSelectorAutoComplete_GoogleAPI';

$(document).foundation();

$(function () {

    Sys.WebForms.PageRequestManager.getInstance().add_pageLoaded(function () {
        initSelect();
    });
    // Run modules

    initLazyload();
    initHeader();
    initSliders();
    initEllipsis();
    initSelect();
    initMap();
    initServiceMap();
    initForms();
    initLocationSelector();
    // FillPostal();
    productFilter();
    fitvids();

});



$(document).ready(function () {

    if ($(".LogoAnimation").length) {
        var animate = lottie.loadAnimation({
            container: $('.LogoAnimation')[0], // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,            
            path: '/NSWMealsOnWheels/Animations/LogoFiller/Logo60.json' // the path to the animation json
        });
        animate.setSpeed(0.2);
    }

    if ($(".IntroLogoAnimation").length) {
        var animate = lottie.loadAnimation({
            container: $('.IntroLogoAnimation')[0], // the dom element that will contain the animation
            renderer: 'svg',
            loop: false,
            autoplay: true, 
            path: '/NSWMealsOnWheels/Animations/IntroScreenV3/IntroScreen.json' // the path to the animation json
        });
        animate.setSpeed(0.8);
        animate.addEventListener('complete', function () { document.location.href = '/Stop-The-Spread'; });
    }
    

     


    $('.mobSideNav ul.select-options li').click(function (e) {
        var value = $(this).attr('rel');
        if (value !== null) {
            if (value !== "") {
                window.location.href = value + ".aspx";
            }
        }
    });
    $('.search__button').click(function (e) {
        var value = $('.search__term').val();
        if (value !== null) {
            if (value !== "") {
                window.location.href = "/Search-Results.aspx?searchtext=" + value;
            }
        }
    });
    $('.mobNav__searchButton').click(function (e) {
        var value = $('.mobNav__searchTerm').val();
        if (value !== null) {
            if (value !== "") {
                window.location.href = "/Search-Results.aspx?searchtext=" + value;
            }
        }
    });

    $('.search__term').keypress(function (event) {


        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            event.preventDefault();
            var value = $('.search__term').val();
            if (value !== "") {
                window.location.href = "/Search-Results.aspx?searchtext=" + value;
            }
        }
        event.stopPropagation();
    });

    $('.RecipeFilterInput').click(function (e) {
        var activeCount = 0;

        $(".recipe__slide").hide();
        $(".RecipeFilterInput").each(function () {
            if ($(this).is(":checked")) {
                activeCount++;
                $(".recipe__slide[data-value*='" + $(this).val() + "']").show();
            }
        });

        if (activeCount == 0) {
            $(".recipe__slide").show();
        }
    });


    
    $(".add-to-cart-button").on("click", function (e) {
        $("#ctl00_Header_lnkCart").show();
    });
    //$('#SameAsStreetAddy').click(function (e) {


    //    var unitPostal = $('#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_UnitNo_txtText').val();
    //    var unitStreet = $('#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_StreetUnitNo_txtText').val();
    //    if (document.getElementById("SameAsStreetAddy").checked == true) {
    //        console.log("checked!");
    //        unitPostal = unitStreet;
    //    } else {
    //        console.log("unchecked!")
    //    }
    //});





    //var bindGroups = function () {
    //    // First copy values
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$UnitNo$txtText']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetUnitNo$txtText']").val());
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalAddress1$txtText']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress1$txtText']").val());
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalAddress2$txtText']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress2$txtText']").val());
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalSuburb$txtText']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetSuburb$txtText']").val());
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalPostcode$txtText']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetPostcode$txtText']").val());

    //    // Dropdown menu copy values
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalState$dropDownList']").val($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetState$dropDownList']").val());

    //    // Then bind fields
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetUnitNo$txtText']").keyup(function () {
    //        $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$UnitNo$txtText']").val($(this).val());
    //    });
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress1$txtText']").keyup(function () {
    //        $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalAddress1$txtText']").val($(this).val());
    //    });
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress2$txtText']").keyup(function () {
    //        $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalAddress2$txtText']").val($(this).val());
    //   });

    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetSuburb$txtText']").keyup(function () {
    //        $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalSuburb$txtText']").val($(this).val());
    //    });

    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetPostcode$txtText']").keyup(function () {
    //        $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalPostcode$txtText']").val($(this).val());
    //    });


    //    // Dropdown bind fields
    //    //$("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetState$dropDownList']").keyup(function () {
    //    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalState$dropDownList']").val($(this).val());
    //    //});
    //    //$("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetState$dropDownList']").val().append($("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$PostalState$dropDownList']").val());
    //    //$("#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_PostalState_dropDownList .select-styled").html($("#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_StreetState_dropDownList .select-styled").html());

    //    $('#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_ncppostalstate .select .select-styled span').html($('#ctl00_ContentPlaceHolder1_edContent_widget1_ctl00_formUser_ncpstreetstate .select .select-styled span').html());

    //};

    //var unbindGroups = function () {
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetUnitNo$txtText']").unbind("keyup");
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress1$txtText']").unbind("keyup");
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetAddress2$txtText']").unbind("keyup");
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetSuburb$txtText']").unbind("keyup");
    //    $("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetPostcode$txtText']").unbind("keyup");
    //    //$("input[name='ctl00$ContentPlaceHolder1$edContent$widget1$ctl00$formUser$StreetState$dropDownList']").unbind("select");
    //};

    $("#ctl00_ContentPlaceHolder1_edWebParts_widget3_ctl00_EmailUpdates").click(function () {
        $("form").submit()
        event.preventDefault();
    });
    $("#ctl00_ContentPlaceHolder1_edWebParts_widget4_ctl00_EmailUpdates").click(function () {
        $("form").submit()
        event.preventDefault();
    });
    if (document.location.search.indexOf("ui=") != -1) {
        $("body,html").animate(
            {
                scrollTop: $(".volunteerForm").offset().top
            },
            800 //speed
        );
    }

    if (window.location.href.indexOf("Donate-now/Thank-you?referrer=aww") > -1 || window.location.href.indexOf("Donate-now/Thank-you?referrer=take5") > -1) {
        $('.DonateThanksCopy').last().html('As a thank you for your support <b>Magshop are offering 15% off</b> selected magazine subscriptions for a limited time only. To take advantage of this special offer visit <a href="https://www.magshop.com.au/" target="_blank">magshop.com.au</a> and use promotion code <b>mownsw</b>');
        
    }



    
});



export default function enableDonate() {
    document.getElementById("donate__button").disabled = false;
    document.getElementById("donate__button--span").innerHTML = "Donate";
}

/************************************************************
    Label recipe steps
************************************************************/
$(document).ready(function () {
    $(".method ul, .method ol").each(function () {
        $(this).find("li").each(function (index, value) {
            $(this).addClass("step").attr("data-step", index + 1).attr("tabindex", 0);
        });
    });
});